/**
 * @fileoverview Await Page
 * This Page displays a waiting screen to inform users that their information
 * is being reviewed.
 *
 * @module Await
 */

import { useState, useEffect } from "react"
import { Col, Row, Spin } from "antd"
import { useNavigate } from "react-router-dom"
import espera from "../assets/images/espera.webp"
import "../assets/styles/LoginPage.css"
import logo from "../assets/images/logo2.svg"
import { useTranslation } from "react-i18next"
import { getMyUser } from "../services/AuthServices"
import { useAuth } from "../contexts/authContext"

/**
 * Await Page that displays a waiting screen
 *
 * @returns {JSX.Element} Await Page
 */
const Await = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [checkingStatus, setCheckingStatus] = useState(true)
  const { getToken } = useAuth()

  /**
   * Check user's veterinary and active status on component mount
   */
  useEffect(() => {
    const checkUserStatus = async () => {
      try {
        setCheckingStatus(true)
        const token = await getToken()

        if (!token) {
          navigate("/login")
          return
        }

        const userData = await getMyUser(token)

        if (!userData || !userData.veterinary) {
          navigate("/preconfirmacion")
          return
        }

        if (userData.active) {
          navigate("/postconfirmacion")
          return
        }
      } catch (error) {
        console.error("Error checking user status:", error)
      } finally {
        setCheckingStatus(false)
      }
    }

    checkUserStatus()
  }, [getToken, navigate])

  /**
   * Handles the continue button click, navigating to the home page
   */
  const handleContinue = () => {
    navigate("/")
  }

  return (
    <div className="body">
      {checkingStatus ? (
        <div
          className="loading-container"
          style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
        >
          <Spin size="large" />
          {/* <p style={{ marginLeft: "12px" }}>{t("common.loading")}</p> */}
        </div>
      ) : (
        <Row className="content">
          <Col lg={10} sm={24} xs={24} className="newleftside">
            <div>
              <img src={espera || "/placeholder.svg"} alt="ovejero" className="dogimage2" />
            </div>
          </Col>
          <Col lg={14} sm={24} xs={24} className="rightside">
            <Col span={24}>
              <Col span={24} className="rightside-container6">
                <div className="container">
                  <img src={logo || "/placeholder.svg"} alt="Logo" className="awaitlogo" />
                  <p className="subtitle4">{t("awaitPage.reviewingInfo")}</p>
                  <p className="subtitle3">{t("awaitPage.notTakeLong")}</p>
                  <button className="button7" onClick={handleContinue}>
                    {t("awaitPage.returnToMain")}
                  </button>
                </div>
              </Col>
            </Col>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default Await
